<template>
  <div id="app">
        <InfoToast />
        <loading ref="loading" />
        <transition name="page" mode="out-in">
            <component :is="layout" v-if="layout" />
        </transition>
  </div>
</template>

<script>
import Loading from "./Loading";
import InfoToast from "£lement/InfoToast";
// Load layout components dynamically.
const requireContext = require.context("~/layouts", false, /.*\.vue$/);
const layouts = requireContext
  .keys()
  .map(file => [file.replace(/(^.\/)|(\.vue$)/g, ""), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component.default || component;
    return components;
  }, {});

export default {
  el: "#app",

  components: {
    Loading,
    InfoToast
  },

  data: () => ({
    layout: null,
    defaultLayout: "default"
  }),

  metaInfo() {
    const appName = "Leadgrease";

    return {
      title: appName,
      titleTemplate: `%s - ${appName}`
    };
  },

  mounted() {
    this.$loading = this.$refs.loading;
  },

  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout;
      }
      this.layout = layouts[layout];
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/app.scss";
</style>
